import { cn } from '../../lib/cn';
import type { AIGovernanceRow } from '../../masterplatform/framework';

type Props = { items?: AIGovernanceRow[] };

export function AIGovernancePanel({ items = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {items.map((item) => (
        <div key={item.layer} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-medium">{item.layer}</p>
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              item.status === 'enforced' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              item.status === 'active' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
              'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
            )}>
              {item.status}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.detail}</p>
        </div>
      ))}
    </div>
  );
}
